import React from 'react';

export const Authentication = React.createContext();

export default class AuthenticationProvider extends React.PureComponent {
  constructor(props){
    super(props)
    this.state= {
      state:{
        name: "Geminious Drigon",
        isAuthenticated: false,
        firstTimeSignin: false,
        user: null,
      },
      setUser: this.setUser.bind(this),
      onSignin: this.onSignin.bind(this)
    }
  }

  setUser(user){
    this.setState({
      user
    })
  }

  onSignin(user, isAuthenticated){
    console.log("context:",user)
    this.setState({
      state:{
        user,
        isAuthenticated,
        firstTimeSignin:true
      },
    })
  }
  
  

  render(){
    return(
      <Authentication.Provider value={this.state} >
        {this.props.children}
      </Authentication.Provider>
    )
  }
}